import React from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

export function withRouter(Component) {
  function WithRouterWrapper(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams] = useSearchParams();

    const history = {
      push: (path, state) => {
        if (typeof path === 'object') {
          navigate(path.pathname + (path.search || ''), { state: path.state });
        } else {
          navigate(path, { state });
        }
      },
      replace: (path, state) => {
        if (typeof path === 'object') {
          navigate(path.pathname + (path.search || ''), { replace: true, state: path.state });
        } else {
          navigate(path, { replace: true, state });
        }
      },
      goBack: () => navigate(-1),
      go: (n) => navigate(n),
      location,
    };

    const match = {
      params,
      path: location.pathname,
      url: location.pathname,
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={match}
        params={params}
        navigate={navigate}
        searchParams={searchParams}
      />
    );
  }

  WithRouterWrapper.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;

  // Preserve static properties (like requiresLogin, serverFetch)
  Object.keys(Component).forEach(key => {
    if (key !== 'prototype') {
      WithRouterWrapper[key] = Component[key];
    }
  });

  return WithRouterWrapper;
}

export default withRouter;
